require('./retailLoanSuccess.scss');
require('./retailLoanSuccess.override.scss');
// @vendor
const React = require('react');
const PropTypes = require('prop-types');
// @core
const { formatText, FormattedText } = require('core/i18n').i18n;
//@components
const { RetailLoanCatalogModal } = require('../retailLoanCatalogModal/retailLoanCatalogModal');
const RetailLoanConfirmAddress = require('../retailLoanConfirmAddress/retailLoanConfirmAddress');
const RetailLoanPickupAddress = require('../../contractRetailLoan/retailLoanPickupAddress/retailLoanPickupAddress');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
//@commons
const { OKButton } = require('commonsComponents/OKButton');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const { OKMessage } = require('commonsComponents/OKMessage');
//@constants
const { configOkLoans, DEFAULT_LOANS_DECIMALS_LENGTH } = require('../../../../loansConstants/index');
//@utilities
const { getFormattedString } = require('utilities/currencyHelper');
const { formatDate } = require('utilities/dateHelper');
const { isRetailAddressDelivery } = require('../../../../loansUtilities/loansHelper');

class RetailLoanSuccess extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false
        }

        this.handleToggleModal = this.handleToggleModal.bind(this);
    }

    handleToggleModal() {
        this.setState({
            showModal: !this.state.showModal
        });
    }

    buildMainButton() {
        //set up redirection link for right bottom button
        return {
            label: formatText('retailLoanSuccess-goBackLinkText').toUpperCase(),
            url: '/myprofile/global'
        };
    }

    buildDeviceImage(immSelectedItem) {
        const productImageURI = immSelectedItem ? immSelectedItem.getIn(['field_product_images', 0, 'url']) : '';

        return immSelectedItem ? (
            <img className="retail-loan-success__image" src={productImageURI} />
        ) : null;
    }

    buildDeviceInfo(immSelectedItem, title, currency) {
        const { showModal } = this.state;
        const description = immSelectedItem ? immSelectedItem.get('field_product_description') : '';
        const modalSpecs = immSelectedItem ? (
            <RetailLoanCatalogModal
                showModal={showModal}
                onHandleToggleModal={this.handleToggleModal}
                item={immSelectedItem}
                labels={configOkLoans(formatText, immSelectedItem, currency)}
                hideActionSection
            />
        ) : null;

        return (
            <div className="retail-loan-success__device-info">
                <div className="retail-loan-success__device-title">{title}</div>
                <div className="retail-loan-success__device-message">
                    {description}
                </div>
                <div>
                    <OKButton
                        modifier="link-complementary"
                        onClick={this.handleToggleModal}
                    >
                        <FormattedText value="retailLoanSuccess-specs" />
                    </OKButton>
                    {modalSpecs}
                </div>
            </div>
        );
    }

    buildInformativeText() {
        const { defaultEmail } = this.props;

        return (
            <div className="retail-loan-success__container-informative-text">
                <OKMessage>
                    <FormattedText
                        value="retailLoanSuccess-informativeText"
                        injectedStrings={[defaultEmail]}
                    />
                </OKMessage>
            </div>
        );
    }

    buildAddress() {
        const { immRetailLoan, immProfile, email } = this.props;
        const isSelected = immRetailLoan.getIn(['personalData', 'isSelected']);
        const personalData = isSelected ? immRetailLoan.get('personalData') : immRetailLoan.get('otherAddress');

        return (
            <RetailLoanConfirmAddress
                className="retail-loan-success__address"
                phoneText="retailLoanSuccess-phoneNumber"
                email={email}
                immProfile={immProfile}
                immAddress={personalData}
            />
        );
    }

    buildPickupAddress() {
        const { immRetailLoan } = this.props;

        return (
            <RetailLoanPickupAddress
                immOffice={immRetailLoan.get('selectedPickup')}
            />
        )
    }

    buildFieldsRight(immSelectedItem, isAddressType) {
        const address = this.buildAddress();
        const deliveryDate = formatDate(immSelectedItem.get('deliveryDate'));

        const urlImageProvider = immSelectedItem.get('field_retail_provider') ? immSelectedItem.get('field_retail_provider').get('image') : '';
        const openDigital = (<img className="retail-loan-success__market-success" src={urlImageProvider} />);

        let estimatedDeliveryDate;
        let deliveryBy = null;
        let addressInformation;

        if (isAddressType) {
            estimatedDeliveryDate = {
                title: formatText('retailLoanSuccess-deliveryDate'),
                bodyText: deliveryDate
            };
            deliveryBy = {
                title: formatText('retailLoanSuccess-deliveryBy'),
                bodyText: openDigital
            };
            addressInformation = {
                title: formatText('retailLoanSuccess-address'),
                bodyText: address
            };

            return [
                estimatedDeliveryDate,
                deliveryBy,
                addressInformation
            ];
        } else {
            const pickupAddress = this.buildPickupAddress();

            deliveryBy = {
                title: formatText('retailLoanSuccess-retailLoanSuccess_soldBy'),
                bodyText: immSelectedItem.getIn(['field_retail_provider', 'provider'])
            };
            addressInformation = [
                {
                    title: formatText('retailLoanSuccess-retailLoanSuccess_billingAddress'),
                    bodyText: address
                },
                {
                    title: formatText('retailLoanSuccess-retailLoanSuccess_pickupAddress'),
                    bodyText: pickupAddress
                }
            ];

            return [
                deliveryBy,
                ...addressInformation
            ];
        }
    }


    buildLoanInfo(immSelectedItem, isAddressType) {
        const { immRetailLoan } = this.props;
        const currency = immRetailLoan.get('currency');

        const amount = getFormattedString({
            amount: immSelectedItem.get('field_total_product_price'),
            currency,
            decimalsLenght: DEFAULT_LOANS_DECIMALS_LENGTH
        });
        const term = formatText('retailLoanSuccess-termMonths', [immRetailLoan.get('selectedTerm')]);
        const payment = getFormattedString(immRetailLoan.get('installment'))

        const fieldsLeft = [
            {
                title: formatText('retailLoanSuccess-payment'),
                bodyText: payment
            },
            {
                title: formatText('retailLoanSuccess-amount'),
                bodyText: amount
            },
            {
                title: formatText('retailLoanSuccess-term'),
                bodyText: term
            }
        ];
        const fieldsRight = this.buildFieldsRight(immSelectedItem, isAddressType);

        const mapFields = (field, index) => {
            return (
                <OKInformativeListItem
                    className="retail-loan-success__list-item"
                    key={field.title + index}
                    title={field.title}
                    bodyText={field.bodyText}
                    information={field.information}
                />
            );
        };

        const itemsLeft = fieldsLeft.map(mapFields);
        const itemsRight = fieldsRight.map(mapFields);

        return (
            <div className="row">
                <div className="col-xs-4">
                    <OKInformativeList columns={1}>
                        {itemsLeft}
                    </OKInformativeList>
                </div>
                <div className="col-xs-8 retail-loan-success__right-content">
                    <OKInformativeList columns={1}>
                        {itemsRight}
                    </OKInformativeList>
                </div>
            </div>
        );
    }

    buildContent() {
        const { immRetailLoan } = this.props;

        const selectedItemId = immRetailLoan.get('purpose');
        const immProducts = immRetailLoan.get('products');
        const currency = immRetailLoan.get('currency');
        const immSelectedItem = immProducts.find(immItem => selectedItemId === immItem.get('nid'));
        const title = immSelectedItem ? immSelectedItem.get('title') : '';
        const isAddressType = isRetailAddressDelivery(immSelectedItem.get('field_pickup_option'));

        const successMessage = formatText('retailLoanSuccess-successMessage');
        const textSubMessage = isAddressType ? 'retailLoanSuccess-subMessage' : 'retailLoanSuccess-retailLoanSuccess_subMessage';
        const subMessage = formatText(textSubMessage, [title]);

        const goToGlobalPosition = this.buildMainButton();
        const informativeText = this.buildInformativeText();
        const deviceImage = this.buildDeviceImage(immSelectedItem);
        const deviceInfo = isAddressType ? this.buildDeviceInfo(immSelectedItem, title, currency) : null;
        const loanInfo = immSelectedItem ? this.buildLoanInfo(immSelectedItem, isAddressType) : null;
        const tealiumData = {
            event_name: "step_success",
            pageName: "/openMarketsInformation/success",
            sectionFamily: "banking",
            sectionCategory: "products",
            sectionName: "loans",
            serviceType: "productContracting",
            interactionType: "funnel",
            processType: "openMarketsInformation",
            processStep: "success",
            productName: "openMarkets",
        };

        return (
            <WizardSuccess
                customClassName="retail-loan-success"
                successMessage={successMessage}
                successMessageChildren={subMessage}
                mainButton={goToGlobalPosition}
                secondaryButtonStyle="link-complementary"
                tealium={tealiumData}
                isSecondVersion
            >
                <div className="retail-loan-success__content-landing">
                    <div className="row">
                        <div className="col-sm-4">
                            {deviceImage}
                        </div>
                        <div className="col-sm-8">
                            {loanInfo}
                        </div>
                    </div>
                    {deviceInfo}
                    {informativeText}
                </div>
            </WizardSuccess>
        );
    }

    render() {
        const content = this.buildContent();

        return (
            <article className="row no-gutter">
                <div className="col-xs-offset-1 col-xs-9">
                    {content}
                </div>
            </article>
        );
    }
}

RetailLoanSuccess.propTypes = {
    defaultEmail: PropTypes.string,
    email: PropTypes.string,
    immRetailLoan: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired
};

module.exports = RetailLoanSuccess;
